import type { ApiRequest, ApiRequestWith } from "@/api/types";
import type { CosignatureSupervisors, UserPermissions } from "@/core/types";
import { httpAuth } from "@/api/httpAuth";
import type { PostUserPermissionsPayload } from "@/core/types/(api)/permissions";

type PermissionsRequestsTyped = {
  get_cosign_supervisors: ApiRequest<CosignatureSupervisors>;
  get_user_permissions: ApiRequestWith<UserPermissions, { urlParams: { userId: string } }>;
  update_user_permissions: ApiRequestWith<
    UserPermissions,
    { body: PostUserPermissionsPayload; urlParams: { userId: string } }
  >;
};

export const permissionsRequestsTyped: PermissionsRequestsTyped = {
  get_cosign_supervisors: function ({ context } = {}) {
    return httpAuth
      .get("/v1/permissions/cosign_supervisors", {
        context: { preventAllErrorToast: true, showLoader: false, ...context },
      })
      .json<CosignatureSupervisors>();
  },

  get_user_permissions: function ({ context, urlParams }) {
    return httpAuth
      .get(`/v1/user/${urlParams.userId}/permissions`, {
        context: { preventAllErrorToast: true, showLoader: false, ...context },
      })
      .json<UserPermissions>();
  },

  update_user_permissions: function ({ body, context, urlParams }) {
    return httpAuth
      .post(`/v1/user/${urlParams.userId}/permissions`, {
        context: { preventAllErrorToast: true, showLoader: false, ...context },
        json: body,
      })
      .json<UserPermissions>();
  },
};
